import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Block from '../Block'
import RemoveBlockButton from '../Calculator/RemoveBlockButton'
import { CalculatorContext } from '../Context/CalculatorContext'
import sliders from '../../templates/sliders'
import Slider from '../Slider'
import { calculateMigrationCost } from '../../model/calculator/calculator'

const MigrationBlock = ({ cost, setCost, setShowBlock }) => {
    const [migration, setMigration] = useState(0)
    const { currency, tooltips } = useContext(CalculatorContext)

    useEffect(() => {
        setCost(calculateMigrationCost(migration))
    }, [migration, setCost, currency])

    const handleRemoveBlock = () => {
        setCost(0)
        setShowBlock(false)
    }

    return (
        <Block
            currency={currency}
            cost={cost}
            title={'Migration'}
            startOpen={true}
        >
            <RemoveBlockButton onClick={handleRemoveBlock} />
            <Slider
                {...sliders.migration}
                tooltip={tooltips.migration}
                value={migration}
                onChange={setMigration}
            />
        </Block>
    )
}

MigrationBlock.propTypes = {
    cost: PropTypes.number,
    setCost: PropTypes.func,
    setShowBlock: PropTypes.func
}

export default MigrationBlock
